import baustein from "baustein";
import renderReactComponentInDocument from "web/script/utils/render-react";
import Tooltip from "web/react/components/tooltip/tooltip";

export default baustein.register("react-tooltip", {
    defaultOptions: {
        direction: "bottom",
        arrow: true,
        autoShow: false,
        autoHide: false,
    },

    onInsert() {
        renderReactComponentInDocument(
            Tooltip,
            {
                ...this.options,
                children: this.el.innerHTML,
            },
            this.el
        );
    },
});
